import {
    Leaf,
    ShieldUser,
    User
} from "lucide-react"

import {
    MOD_SDG,
    MOD_SYSTEM_USER,
    MOD_APP_USER,
} from "@/configs/ModulesConfig"


export const SYSTEM_USER_NAVIGATION_ITEMS = [
    {
        id: MOD_APP_USER.id,
        title: MOD_APP_USER.name_plural,
        url: MOD_APP_USER.routes.list,
        icon: <User className="text-purple-700 w-4 h-4" />,
        bgClass: "bg-purple-100 text-purple-700 hover:bg-purple-200 border border-purple-200"
    },
    {
        id: MOD_SYSTEM_USER.id,
        title: MOD_SYSTEM_USER.name_plural,
        url: MOD_SYSTEM_USER.routes.list,
        icon: <ShieldUser className="text-blue-700 w-4 h-4" />,
        bgClass: "bg-blue-100 text-blue-700 hover:bg-blue-200 border border-blue-200"
    },
    {
        id: MOD_SDG.id,
        title: MOD_SDG.name_plural,
        url: MOD_SDG.routes.list,
        icon: <Leaf className="text-green-700 w-4 h-4" />,
        bgClass: "bg-green-100 text-green-700 hover:bg-green-200 border border-green-200"
    },
]
export const APP_USER_NAVIGATION_ITEMS = [

]